import { timelineMain } from "./timeline-main/timeline-main.module";
import { timelineAdd } from "./timeline-add/timeline-add.module";
import { timelineEdit } from "./timeline-edit/timeline-edit.module";
import { timelineList } from "./timeline-list/timeline-list.module";
import { timelineDetails } from "./timeline-detail/timeline.details.module";
import { timelineSequence } from "./timeline-sequence/timeline-sequence.module";
import { timelineQuestionsList } from "./timeline-questions/timeline-questions-list.module";
import { timelineMultipleQuestions } from "./timeline-multiple-questions/timeline-multiple-questions.module";
import { TimelineService } from "./timeline.service";
import "./timeline.scss";

export const timeline = angular
  .module("components.timeline", [
    timelineMain,
    timelineAdd,
    timelineEdit,
    timelineList,
    timelineDetails,
    timelineSequence,
    timelineQuestionsList,
    timelineMultipleQuestions,
  ])
  .service("TimelineService", TimelineService).name;



// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline.module.js